// extracted by mini-css-extract-plugin
export default {"root":"FilterDrawer_root__ahXAp","containerClassName":"FilterDrawer_containerClassName__7oT95"};